import { axios } from "~/plugins/request"

export const state = () => {
  return {}
}
export const mutations = {}
export const actions = {
  getProvince({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`ArtExamination/getProvince`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  selectServiceConditionList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`ArtExamination/selectServiceConditionList`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  findGradeInfoList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`ArtExamination/findGradeInfoList`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  findServiceConditionExportScheme({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`ArtExamination/findServiceConditionExportScheme`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  importExcel({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/artCheckAndImport/importExcel`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  exportScheme({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/artCheckAndImport/exportScheme`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  exportData({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`artCheckAndImport/exportData`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  exportReload({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`artCheckAndImport/exportReload`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // exportData({ commit }, params) {
  //   return new Promise((resolve, reject) => {
  //     axios({
  //       method: 'post',
  //       url: '/customer/exportData',
  //       data: params,
  //       responseType: 'blob',
  //       headers: {
  //         'Content-Type': 'application/json'
  //       }
  //     }).then(response => {
  //       resolve(response)
  //     }).catch((error) => {
  //       reject(error)
  //     })
  //   })
  // },

}
